import { FormArray, FormControl, FormGroup } from '@angular/forms';

export function validateAllFormFields(formGroup: FormGroup | FormArray) {
  Object.keys(formGroup.controls).forEach((field) => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      //TRICK żeby się error pojawił
      control.setValue(control.value, { emitEvent: true });
      control.markAsTouched({ onlySelf: true, emitEvent: true });
      control.markAsDirty({ onlySelf: true, emitEvent: true });
    } else if (control instanceof FormGroup || control instanceof FormArray) {
      validateAllFormFields(control);
    }
  });
}
